import { AlertTriangle, X } from "lucide-react";
import { StockWarning } from "@/redux/services/inventory/inventory.type";
import { stripTrailingZeros } from "@/lib/utils";

interface StockWarningsBannerProps {
  warnings: StockWarning[];
  onDismiss?: () => void;
}

const StockWarningsBanner = ({
  warnings,
  onDismiss,
}: StockWarningsBannerProps) => {
  if (warnings.length === 0) return null;

  return (
    <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 space-y-2">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2">
          <AlertTriangle className="h-5 w-5 text-orange-500 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-orange-900">
              Stock insuffisant détecté
            </p>
            <p className="text-xs text-orange-700">
              La commande a été enregistrée, mais certains ingrédients sont en
              rupture :
            </p>
          </div>
        </div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="text-orange-500 hover:text-orange-700 flex-shrink-0"
            aria-label="Fermer"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <ul className="space-y-1 pl-7">
        {warnings.map((w) => (
          <li key={w.ingredientUuid} className="text-xs text-orange-800">
            <span className="font-medium">{w.name}</span> — manque{" "}
            <span className="font-semibold">
              {stripTrailingZeros(w.shortfall)}
            </span>{" "}
            (requis {stripTrailingZeros(w.required)}, disponible{" "}
            {stripTrailingZeros(w.available)})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StockWarningsBanner;
